import { AuthPage } from 'app/modules/auth';
import PrivacyPolicy from 'app/modules/auth/components/PrivacyPolicy';
import TnC from 'app/modules/auth/components/TnC';
import JobFairAuthComponent from 'app/modules/job-seeker/JobfairAuth';
import JobFairJoinComponent from 'app/modules/job-seeker/JobfairJoin';
import Home from 'app/modules/public/Home';
import SponsorClientInvite from 'app/modules/public/SponsorClientInvite';
import SponsorView from 'app/modules/public/SponsorView';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

export function PublicRoutes () {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const subdomain = parts.length > 2 ? parts[0] : null;
  const location = useLocation();

  const isSponsorSubdomain =
    subdomain != null &&
    subdomain !== 'www' &&
    subdomain !== 'main' &&
    hostname !== 'localhost';

  return (
    <>
      {isSponsorSubdomain
        ? (
          <Switch>
            <Route path='/client-invite' render={() => <SponsorClientInvite subdomain={subdomain} />} />
            <Route path='/jobfairs' render={() => <SponsorView subdomain={subdomain} />} />
            <Route path='/home' component={Home} />
            <Redirect to='/jobfairs' />
          </Switch>
          )
        : (
          <Switch>
            <Route path='/auth' component={AuthPage} />
            <Route path='/home' component={Home} />
            <Route path='/terms-and-conditions' component={TnC} />
            <Route path='/privacy-policy' component={PrivacyPolicy} />
            <Route path='/join/:alias' component={JobFairJoinComponent} />
            <Route path='/job-seeker/organizations/:orgId/jobfairs/:jobFairId' render={() => <JobFairAuthComponent />} />
            <Redirect
              to={{
                pathname: '/auth/login',
                state: { returnUrl: location.pathname.indexOf('logout') > -1 ? undefined : location.pathname + location.search }
              }}
            />
          </Switch>
          )
      }
    </>
  );
}
